import  Prism from 'prismjs'

const VuePrism = {

    install (Vue, options) {

        Vue.mixin({
            mounted () {
                Prism.highlightAll();
            }
        })
    }
}

export default VuePrism;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-prism/src/index.js
// module id = 808
// module chunks = 0